import { AxiosResponse } from "axios";

import { conversationAxios } from "../../../Utils";
import { getHttpService } from "../../HttpService";
import { FLOW_BUILDER_ENDPOINTS, FLOW_VERSION_ENDPOINTS } from "../Endpoints";

export class FlowBuilderService {
  static httpService = getHttpService(conversationAxios);

  static getFlowById = (flowId = "", config = {}, version_id = ""): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.get({
      url: FLOW_BUILDER_ENDPOINTS.GET_FLOW,
      headers: config,
      pathParams: [flowId],
      params: { version_id }
    });
  };

  //copy flow
  static copyFlow = (id = "", bot_id = ""): Promise<AxiosResponse<any>> => {
    console.log("Bot is is=====", bot_id)
    const appid = {
      botid: bot_id,
      channel: "website",
    };
    return FlowBuilderService.httpService.put({
      url: FLOW_BUILDER_ENDPOINTS.CLONE_FLOW,
      headers: {
        // ...config,
        appid: JSON.stringify(appid),
      },
      pathParams: [id],
    });
  };

  static getFlows = (
    queryData = {},
    config = {}
  ): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.get({
      url: FLOW_BUILDER_ENDPOINTS.GET_FLOWS,
      params: queryData,
      headers: config,
    });
  };

  static createFlow = (data = {}, config = {}): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.post({
      url: FLOW_BUILDER_ENDPOINTS.CREATE_FLOW,
      data,
      headers: config,
    });
  };

  static updateFlow = (
    id = "",
    queryData = {},
    config = {}
  ): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.put({
      url: FLOW_BUILDER_ENDPOINTS.UPDATE_FLOW,
      data: queryData,
      headers: config,
      pathParams: [id],
    });
  };

  static deleteFlow = (
    id = "",
    queryData = {},
    config = {}
  ): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.httpDelete({
      url: FLOW_BUILDER_ENDPOINTS.DELETE_FLOW,
      data: queryData,
      headers: config,
      pathParams: [id],
    });
  };

  static createNode = (data = {}, config = {}): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.post({
      url: FLOW_BUILDER_ENDPOINTS.CREATE_NODE,
      data,
      headers: config,
    });
  };

  static updateNode = (data = {}, config = {}): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.put({
      url: FLOW_BUILDER_ENDPOINTS.UPDATE_NODE,
      data,
      headers: config,
    });
  };

  static deleteNode = (data = {}, config = {}): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.httpDelete({
      url: FLOW_BUILDER_ENDPOINTS.UPDATE_NODE,
      data,
      headers: config,
    });
  };

  static updateNodeStage = (
    data = {},
    config = {}
  ): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.post({
      url: FLOW_BUILDER_ENDPOINTS.UPDATE_NODE_STAGE,
      data,
      headers: config,
    });
  };
  static getWhatsappUserConsent = (
    queryData = {},
    config = {}
  ): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.get({
      url: FLOW_BUILDER_ENDPOINTS.WHATSAPP_USER_CONSENT,
      params: queryData,
      headers: config,
    });
  };
  static updateWhatsappUserConsent = (
    data = {},
    config = {}
  ): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.post({
      url: FLOW_BUILDER_ENDPOINTS.WHATSAPP_USER_CONSENT,
      data,
      headers: config,
    });
  };

  static async getContactPropertyList(): Promise<AxiosResponse<any>> {
    return await FlowBuilderService.httpService.get({
      url: FLOW_BUILDER_ENDPOINTS.CONTACT_PROPERTIES,
    });
  }

  static getApiList = (): Promise<AxiosResponse<any>> => {
    return FlowBuilderService.httpService.get({
      url: FLOW_BUILDER_ENDPOINTS.API_OPTIONS,
    });
  };

  // Apply similar changes to other methods like createBotFlowVersion, listBotFlowVersions, deleteBotFlowVersion
    static createBotFlowVersion = (botid: string, headers: any = {}, version_name?: string) => {
    const data: any = { botid };
    if (version_name) data.version_name = version_name;
    return FlowBuilderService.httpService.post({
      url: FLOW_VERSION_ENDPOINTS.CREATE_VERSION,
      data,
      headers: {
        ...headers,
        appid: JSON.stringify({ botid }),
      }
    });
  };

  static getBotFlowByVersion = (botid: string, versionId: string, headers: any = {}, qid: any) => {
    return FlowBuilderService.httpService.get({
      url: FLOW_VERSION_ENDPOINTS.GET_VERSION_FLOWS,
      params: {
        bot_id: botid,
        version_id: versionId,
        qid: qid
      },
      headers: {
        ...headers,
        appid: JSON.stringify({ botid }),
      },
    });
  };
  static listBotFlowVersions = (botid: string, headers: any = {}) => {
    return FlowBuilderService.httpService.get({
      url: FLOW_VERSION_ENDPOINTS.LIST_VERSIONS,
      params: { botid },
      headers: {
        ...headers,
        appid: JSON.stringify({ botid }),
      }
    });
  };

  static deleteBotFlowVersion = (botid: string, version_id: string, headers: any = {}) => {
    return FlowBuilderService.httpService.post({
      url: FLOW_VERSION_ENDPOINTS.DELETE_VERSION,
      data: { botid, version_id },
      headers: {
        ...headers,
        appid: JSON.stringify({ botid })
      }
    });
  };

    static restoreBotFlowVersion = (botid: string, version_id: string, headers: any = {}) => {
    return FlowBuilderService.httpService.post({
      url: FLOW_VERSION_ENDPOINTS.RESTORE_VERSION,
      data: { botid, version_id },
      headers: {
        ...headers,
        appid: JSON.stringify({ botid })
      }
    });
  };

  static updateBotFlowVersionName = (botid: string, version_id: string, version_name: string, headers: any = {}) => {
    return FlowBuilderService.httpService.put({
      url: FLOW_VERSION_ENDPOINTS.UPDATE_VERSION_NAME,
      pathParams: [version_id],
      data: { version_name },
      headers: {
        ...headers,
        appid: JSON.stringify({ botid })
      }
    });
  };
};


  

